export interface ShippingSummaryRecord_T {
  id: number;
  customer_name?: string;
  customer_id?: string;
  fulfillment_date?: string;
  fulfillment_date_period?: string;
  count_delivery_fulfillments?: number;
  count_volume_upgrades?: number;
  count_customers?: number;
  status_sort_order?: number;
  summary_status?: string;
}

export interface ActiveDeliveryAnalysisDetails_T {
  delivery_id: number;
  delivery_name: string;
  country_code: string;
  analysis_report_date: string;
  duration: number;
  total_volume: number;
  active_volume: number;
  duplicate_volume: number;
  ignored_volume: number;
  // Fields requested by Beth
  google_in_name_volume: number;
  google_in_scrubbed_name_volume: number;
  housing_related_business_cat_volume: number;
  missing_address_volume: number;
  missing_name_volume: number;
  missing_business_cat_volume: number;
  missing_coordinates_volume: number;
  missing_country_code_volume: number;
  profanity_in_name_volume: number;
  profanity_in_scrubbed_name_volume: number;
  scrubbed_name_has_generic_my_value_volume: number;
  // Remaining fields
  missing_city_volume: number;
  outside_city_volume: number;
  outside_state_volume: number;
  wrong_country_volume: number;
  outside_country_volume: number;
  outside_shapefile_volume: number;
  unnamed_road_volume: number;
  address_with_url_volume: number;
  google_plus_code_volume: number;
  name_only_numbers_volume: number;
  nonstandard_state_volume: number;
  missing_postal_code_volume: number;
  name_equals_address_volume: number;
  address_only_numbers_volume: number;
  scrubbed_name_with_url_volume: number;
  name_with_potential_url_volume: number;
  scrubbed_name_very_long_volume: number;
  website_contains_google_volume: number;
  scrubbed_name_with_emoji_volume: number;
  name_equals_generic_value_volume: number;
  scrubbed_address_with_url_volume: number;
  address_with_potential_url_volume: number;
  scrubbed_address_with_emoji_volume: number;
  wrong_reverse_geocode_country_volume: number;
  expected_name_equals_address_volume: number;
  name_has_invalidating_string_volume: number;
  scrubbed_address_equals_neighborhood_volume: number;
  scrubbed_name_equals_scrubbed_address_volume: number;
  scrubbed_name_has_invalidating_string_volume: number;
  scrubbed_name_has_unicode_characters_volume: number;
  scrubbed_name_has_unusual_characters_volume: number;
  name_has_repeated_characters_volume: number;
  unexpected_name_equals_address_volume: number;
  unnamed_road_google_code_combo_volume: number;
  scrubbed_name_with_potential_url_volume: number;
  missing_reverse_geocode_country_code_volume: number;
  scrubbed_name_has_vertical_pipe_characters_volume: number;

  // Warning-related fields
  warnings_name_very_long_volume: number;
  warnings_name_very_short_volume: number;
  warnings_address_very_long_volume: number;
  warnings_address_very_short_volume: number;
  warnings_name_overlaps_address_volume: number;
  warnings_name_with_unicode_chars_volume: number;
  warnings_name_with_unusual_chars_volume: number;
  warnings_address_with_unicode_chars_volume: number;
  warnings_address_with_unusual_chars_volume: number;
}

export interface FulfillmentGroupSummary_T {
  id?: number;
  name?: string;
  customer_id?: string;
  customer_name?: string;
  count_deliveries?: number;
  count_countries?: number;
  count_completed?: number;
  delivery_ids?: string[];
  incomplete_delivery_ids?: string[];
  countries?: { id: string; name: string }[];
}
export interface ShippingDetailRecord_T {
  id?: number;
  ad_hoc_ticket_id?: string;
  completion_signal?: string;
  countries?: { id: number; name: string }[];
  customer_id?: number;
  customer_name?: string;
  delivery_id?: number;
  delivery_name?: string;
  delivery_fulfillment_id?: number;
  dest_uri_address_template?: string;
  destination_uri?: string;
  export_completed_at?: string;
  export_duration?: number;
  export_id?: number;
  export_job_id?: number;
  export_s3_uri?: string;
  fgs_id?: number;
  file_size_kb?: number;
  file_type?: string;
  fulfillment_completed_at?: string;
  fulfillment_destination?: string;
  fulfillment_group_id?: number;
  fulfillment_group_name?: string;
  fulfillment_status?: string;
  is_ad_hoc?: boolean;
  license_end_date?: string;
  next_delivery_date?: string;
  previous_delivery_date?: string;
  previous_file_size_kb?: number;
  previous_volume?: number;
  shipping_duration?: number;
  status_display_order?: number;
  status_last_updated?: string;
  target_fulfillment_date?: string;
  volume?: number;
  volume_upgrade_merged?: string;
  volume_upgrade_scheduled?: boolean;
  week_start_date?: string;
  count_exports_failed?: number;
  count_exports_canceled?: number;
  count_fulfillments_failed?: number;
}

export interface ShippingStatusSummary_T {
  status: string;
  count: number;
  percentage: string;
}

export const ShippingDialogTypesT = {
  NONE: "",
  REFRESH_EXPORT: "REFRESH_EXPORT",
  EXPORT: "EXPORT",
  CREATE_SHIPMENT: "CREATE_SHIPMENT",
  DELIVER_SHIPMENT: "DELIVER_SHIPMENT",
  MARK_DELIVERED: "MARK_DELIVERED",
  DELIVER_CHECKSUM: "DELIVER_CHECKSUM",
} as const;

export type ShippingDialogTypeT =
  (typeof ShippingDialogTypesT)[keyof typeof ShippingDialogTypesT];

export interface SelectedShippingGroup_T {
  fulfillmentGroupId: number;
  name: string;
  shipments: ShippingDetailRecord_T[];
}

export interface SelectedShippingData_T {
  fullySelectedGroups: SelectedShippingGroup_T[];
  partiallySelectedGroups: SelectedShippingGroup_T[];
  totalSelectedShipments: number;
}

export interface ShippingDialogProps {
  onClose: () => void;
  customerId: number;
  customerName: string;
  dateStart: string;
  dateEnd: string;
  selectedData: SelectedShippingData_T;
  fulfillmentGroups?: { id: number; name: string }[];
}

export interface FulfillmentError_T {
  id: number;
  customer_name: string;
  customer_id: number;
  delivery_id: number;
  delivery_name: string;
  delivery_fulfillment_id: number;
  target_fulfillment_date: string;
  status: string;
  status_last_updated: string;
  error_message: string;
  export_job_id: number;
}
